const FETCH_LOADING = 'FETCH_LOADING';
const GET_INVITED_NUMBERS = 'GET_INVITED_NUMBERS';
const FETCH_ERROR = 'FETCH_ERROR';
const SET_SHOWING_CONTENT = 'SET_SHOWING_CONTENT';
const SET_POPUP_STATUS = 'SET_POPUP_STATUS';
const SET_ACTIVE_STEP = 'SET_ACTIVE_STEP';
const POPUP_LOADING = 'POPUP_LOADING';
const SET_NEW_LIMITS = 'SET_NEW_LIMITS';
const CHANGE_INVITE_ITEMS = 'CHANGE_INVITE_ITEMS';
const CHANGE_PROCESSING_STATUS = 'CHANGE_PROCESSING_STATUS';
const SET_PRICE_AFTER_DELETE_NUMBER = 'SET_PRICE_AFTER_DELETE_NUMBER';

export {
  FETCH_ERROR,
  FETCH_LOADING,
  GET_INVITED_NUMBERS,
  SET_SHOWING_CONTENT,
  SET_POPUP_STATUS,
  SET_ACTIVE_STEP,
  POPUP_LOADING,
  SET_NEW_LIMITS,
  CHANGE_INVITE_ITEMS,
  CHANGE_PROCESSING_STATUS,
  SET_PRICE_AFTER_DELETE_NUMBER,
};
